var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 0.524187C15.6755 0.524187 15.113 0.746937 14.6795 1.18044L7.25 8.58669L7.08575 8.75094L7.03925 8.98569L6.52325 11.6107L6.28925 12.7117L7.391 12.4777L10.016 11.9617L10.25 11.9152L10.4142 11.7509L17.8205 4.32144C18.1309 4.01023 18.3422 3.6141 18.4278 3.18297C18.5134 2.75183 18.4695 2.30501 18.3015 1.89882C18.1336 1.49263 17.8491 1.14525 17.484 0.90049C17.1189 0.655727 16.6895 0.524529 16.25 0.523438V0.524187ZM16.25 1.97769C16.4255 1.97769 16.5987 2.06769 16.766 2.23494C17.0997 2.56944 17.0997 2.93244 16.766 3.26619L9.5 10.5329L8.21075 10.7909L8.46875 9.50169L15.7347 2.23569C15.9012 2.06919 16.0745 1.97844 16.25 1.97844V1.97769ZM0.5 3.50094V18.5009H15.5V8.60994L14 10.1099V17.0009H2V5.00094H8.891L10.391 3.50094H0.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.efc837aba247c5d240420937f20b2ba7.svg";
export { ForwardRef as ReactComponent };